import { CASES_GENERAL_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useCasesGeneralList } from './hook';
import { CasesGeneralInformationListProps } from './props';

export const CasesGeneralList = ({
    filters,
}: CasesGeneralInformationListProps) => {
    const {
        navigate,
        columns,
        rows,
        loading,
        page,
        pageSize,
        paginator,
        total,
    } = useCasesGeneralList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                navigate(`${CASES_GENERAL_DETAIL}/${item.row.id}`)
            }
        />
    );
};
